module.exports = __webpack_public_path__ + "static/media/instagram-disabled.61bdece7.svg";